import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import { useCreateWZ } from "../../../../../components/WMS/ExReleases/useCreateWZ"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"

type Search = {
  warehouseId?: string
}

type RawSearch = {
  warehouseId?: unknown
}

export const Route = createFileRoute("/_layout/WMS/documents/ex-releases/new")({
  component: CreateExReleaseDraftPage,
  validateSearch: (search: RawSearch): Search => ({
    warehouseId:
      typeof search.warehouseId === "string" ? search.warehouseId : undefined,
  }),
})

function CreateExReleaseDraftPage() {
  const navigate = useNavigate()
  const { warehouseId } = Route.useSearch()
  const { createWZ, isCreating, isResolvingWarehouses, canCreate } =
    useCreateWZ()
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current || isResolvingWarehouses) return
    if (!canCreate) return
    startedRef.current = true
    void createWZ(warehouseId)
  }, [canCreate, createWZ, isResolvingWarehouses, warehouseId])

  const handleCancel = () =>
    navigate({
      to: warehouseId
        ? "/WMS/warehouses/$warehouse"
        : "/WMS/documents/document-list",
      ...(warehouseId
        ? { params: { warehouse: warehouseId } }
        : { search: { page: 1, page_size: 50 } }),
    } as any)

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument WZ"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu WZ..."
      idleLabel="Przygotowywanie edycji dokumentu WZ..."
    />
  )
}
